import './IconButton.css'
import React from 'react'
import classNames from 'classnames'
import { Tooltip } from 'antd'

type Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "submit" | "reset" | "button";
  className?: string;
  children?: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
}

export default function IconButton({ disabled, onClick, type, className, children, tooltip }: Props) {
  return (
    <Tooltip title={tooltip}>
      <button
        onClick={onClick}
        type={type}
        disabled={disabled}
        className={
          classNames([
            'icon-button',
            className
          ])
        }>{children}</button>
    </Tooltip>
  )
}
